<template>
  <div>
    <hr class="border border-black-light-2 my-6" />
    <div @click="onClick" class="flex items-center justify-between px-2">
      <h2 class="font-medium fs-24">Dive facilities</h2>
      <svg width="24" height="24">
        <use xlink:href="/img/sprite.svg#ic_chevron-right--solid"></use>
      </svg>
    </div>

    <zb-modal ref="detailModal" class="slide-in-modal" :no-padding="true">
      <template v-slot:title>
        <h2 class="fs-20 font-medium p-6">Dive facilities</h2>
      </template>

      <template v-slot:default>
        <hr class="border border-black-light-2 mb-6" />
        <div class="px-4">
          <ul class="grid-3 row-gap-4 list-reset col-gap-32 mdsm:col-gap-4">
            <li
              class="flex items-center"
              v-for="(incl, index) in displayingAmenities"
              :key="index"
            >
              <div class="flex-none pr-3">
                <template v-if="incl.type === 'extra'">
                  <svg style="fill: currentColor" width="24" height="24">
                    <use xlink:href="/img/sprite.svg#ic_dollar"></use>
                  </svg>
                </template>
                <template v-else>
                  <svg width="24" height="24">
                    <use xlink:href="/img/sprite.svg#ic_success"></use>
                  </svg>
                </template>
              </div>
              <div class="flex-1">{{ incl.name }}</div>
            </li>
          </ul>
          <div class="w-full">
            <div
              class="box is-blue is-solid px-10 mdsm:px-8 py-4 rounded border border-black-light-2 mt-5"
            >
              <ul>
                <li class="flex flex-wrap">
                  Items marked with an
                  <svg
                    style="fill: currentColor"
                    width="24"
                    height="24"
                    class="mx-1"
                  >
                    <use xlink:href="/img/sprite.svg#ic_dollar"></use>
                  </svg>
                  may not be included in the trip price.
                </li>
                <li>
                  Please check the FAQs below or individual trip details for
                  detailed information about additional costs.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </zb-modal>
  </div>
</template>

<script>
import orderBy from "lodash/orderBy";
import { DIVE_CENTER_FACILITIES } from "../../helpers/constants";

export default {
  props: ["resortId"],
  data() {
    return {
      inclusions: [],
    };
  },
  computed: {
    orderedInclusions() {
      return orderBy(this.inclusions, ["order", "name"], ["asc", "asc"]);
    },

    displayingAmenities() {
      return [...this.included, ...this.extra];
    },
    included() {
      return this.orderedInclusions.filter((incl) => incl.type === "included");
    },
    extra() {
      return this.orderedInclusions.filter((incl) => incl.type === "extra");
    },
    notIncluded() {
      return this.orderedInclusions.filter(
        (incl) => incl.type === "not_included"
      );
    },
    showPopup() {
      return (
        this.notIncluded.length > 0 ||
        this.included.length > 6 ||
        this.extra.length > 6
      );
    },
  },
  methods: {
    onClick() {
      this.$refs.detailModal.show();

      this.$el.querySelector(".zb-modal-scrollable-content").scrollTop = 0;
    },
  },
  mounted() {
    window
      .fetchSupplierInfo(this.resortId)
      .then((res) => {
        if (res.inclusions.length === 0) {
          throw new Error();
        }

        this.inclusions = res.inclusions.filter(
          (incl) => incl.list_id === DIVE_CENTER_FACILITIES
        );
      })
      .catch(() => {
        document
          .querySelector(".resort-original-dive-facilities")
          .classList.remove("hidden");
        document
          .querySelector(".resort-odyssey-dive-facilities")
          .classList.add("hidden");
      });
  },
};
</script>
